import React, { useState } from "react";
export default function Notification(props) {
  const [state] = useState({
    container:
      "fixed text-white bg-black right-0 top-0 w-full sm:w-3/5 lg:w-2/5 transition-all duration-500 flex flex-wrap ml-10",
    menu: [
      { name: "Network", icon: "fas fa-wifi w-full" },
      { name: "Screen", icon: "fas fa-tablet-alt w-full" },
      { name: "Battery", icon: "fas fa-battery-full w-full" },
      { name: "Tablet", icon: "fas fa-tablet w-full" },
      { name: "Hotspot", icon: "fas fa-wifi w-full" },
      { name: "Location", icon: "fas fa-compass w-full" },
      { name: "Bluetooth", icon: "fab fa-bluetooth w-full" },
      { name: "Airplane", icon: "fas fa-plane w-full" },
      { name: "Nearby", icon: "fas fa-share w-full" },
      { name: "Setting", icon: "fas fa-cog w-full" },
      { name: "Connect", icon: "fas fa-network-wired w-full" },
      { name: "Project", icon: "fas fa-tasks w-full" },
      { name: "VPN", icon: "fas fa-ethernet w-full" },
      { name: "Assist", icon: "fas fa-assistive-listening-systems w-full" },
      { name: "Night", icon: "fas fa-moon w-full" },
      { name: "Wifi", icon: "fas fa-wifi w-full" }
    ]
  });
  return (
    <div
      className={state.container}
      style={
        props.open
          ? { height: "calc(100% - 3em)" }
          : { marginRight: -1000, height: "calc(100% - 3em)" }
      }
    >
      <div className="flex w-full mt-4 justify-center overflow-auto">
        <p>No new notifications</p>
      </div>
      <div className="w-full relative">
        <div className="absolute bottom-0">
          <div className="flex flex-wrap">
            {state.menu.map((d, i) => (
              <div
                key={i}
                className="bg-gray-100 text-black w-1/4 flex flex-wrap justify-center text-center p-5 cursor-pointer hover:bg-gray-200"
              >
                <i className={d.icon}></i>
                <span className="text-sm font-light">{d.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
